import { Link } from "@inertiajs/inertia-vue3";
import { computed, defineComponent } from "vue";
export default defineComponent({
    components: {
        Link,
    },
    props: {
        href: {
            type: String,
            default: "",
        },
        icon: {
            type: String,
            default: "",
        },
        active: {
            type: Boolean,
            default: false,
        },
    },
    setup(props) {
        const baseClasses = "text-4xl no-underline";
        const activeClasses = "active text-4xl no-underline";
        const classes = computed(() => {
            return props.active ? activeClasses : baseClasses;
        });
        return {
            classes,
        };
    },
});
